// extracted by mini-css-extract-plugin
module.exports = {"popupDialog":"member-operations__PopupDialogDeprecated__popupDialog"};